import http from '@core/fetch'
export default {
  getFilterListApi: body =>
    http('/p/wedding/index.php/Admin/APIMerchantOrder/filter', { body }), //获取筛选列表
  getListApi: body =>
    http('/p/wedding/index.php/Admin/APIMerchantOrder/list', { body }), //获取订单列表
  getDetailApi: body =>
    http('/p/wedding/index.php/Admin/APIMerchantOrder/info', { body }), //获取订单详情
  deleteTradeOrderApi: body =>
    http.post('/p/wedding/index.php/Admin/APIMerchantOrder/delete', { body }), //删除订单
  getContractDownUrlApi: (orderId, contractId) =>
    http.get('/p/wedding/admin/APIBdContract/contractDownloadUrl', {
      body: { id: orderId, contractId },
      onError: false
    }) // 获取合同下载地址
}
